import { useEffect, useState } from 'react';
import { getPartnershipSettings } from '../../parts/api';

// Public tracking identifiers from the Rakuten API-generated, user-tested links.
// These are not API credentials. Pelican recommends search for OEM-number referrals.
const RAKUTEN_PUBLISHER_ID = 'hfDu8Uf42kY';
const EAH_ADVERTISER_ID = '43304';

export const pelicanPartUrl = (partNumber) => {
  const value = String(partNumber || '').trim();
  const destination = `https://www.pelicanparts.com/search/?q=${encodeURIComponent(value)}`;
  return `https://click.linksynergy.com/deeplink?id=${RAKUTEN_PUBLISHER_ID}&mid=${EAH_ADVERTISER_ID}&murl=${encodeURIComponent(destination)}`;
};

export const usePelicanPartsPartnership = () => {
  const [enabled, setEnabled] = useState(false);
  const [resolved, setResolved] = useState(false);

  useEffect(() => {
    let active = true;
    getPartnershipSettings()
      .then((settings) => {
        if (active) {
          setEnabled(settings?.pelicanPartsLinksEnabled === true);
          setResolved(true);
        }
      })
      .catch(() => {
        // Fail closed: do not expose partner links or catalog pricing without the setting.
      });
    return () => { active = false; };
  }, []);

  return {
    pelicanPartsLinksEnabled: resolved && enabled,
    showCatalogPricing: resolved && !enabled,
  };
};

export const usePelicanPartsLinks = () =>
  usePelicanPartsPartnership().pelicanPartsLinksEnabled;

const PelicanPartNumber = ({ partNumber, enabled, children, className = '' }) => {
  const value = String(partNumber || '').trim();
  const content = children ?? (value || '—');
  if (!enabled || !value) return <span className={className}>{content}</span>;

  return (
    <a
      className={`pelican-part-link ${className}`.trim()}
      href={pelicanPartUrl(value)}
      target="_blank"
      rel="noopener noreferrer sponsored"
      aria-label={`Find part ${value} at Pelican Parts (opens in a new tab)`}
      title="Find this part at Pelican Parts (affiliate link)"
    >
      {content}
    </a>
  );
};

export default PelicanPartNumber;
